<template>
    <v-container  class="evaluate">
        <div v-if="selected_emp.hasOwnProperty('EM_CODE')&&selected_service.hasOwnProperty('serviceD_id')">
            <div class="text-xs-center">
                <h1>ประเมิน{{ selected_service.serviceD_name }}</h1>
            </div>
            <emp-evaluate :selected_service="selected_service" :selected_emp="selected_emp" />
        </div>

        <div v-else-if="selected_service.hasOwnProperty('serviceD_id')">
            <div class="text-xs-center">
                <h1>ประเมิน{{ selected_service.serviceD_name }}</h1>
            </div>
            <div  class="text-xs-center">
                <v-btn v-if="!qrcode_uriMulti" color="info"  large class="text-xs-center blue mt-3 v-btn--round white--text" @click="sendto('qrcode')"><v-icon left>mdi-qrcode</v-icon>แสดง QR Code</v-btn>
                <v-btn v-else color="info"  large class="text-xs-center blue mt-3 v-btn--round white--text" @click="gotoSearch">ค้นหาพนักงาน</v-btn>
            </div>
            <emp-search v-show="!current_state"  @set_selected_emp="setSelectedEmp" :qsearch="prev_emp_qsearch" @set_qsearch="set_qsearch"/>
            <!-- หน้าสร้าง QR code -->
            <eva-qrcode v-if="current_state=='qrcode'" :qrcode_uriMulti="qrcode_uriMulti" :qrcode_uri="qrcode_uri" @back_to_emp="back_to_emp" />
        </div>


        <div v-else @set_selected_service="setSelectedService">
            <select-service @set_selected_service="setSelectedService" :selected_dept_prop="selected_dept" @set_selected_dept="setSelectedDept" />
        </div>

    </v-container>
</template>

<script>

    import EventBus from '@/EventBus'
    import axios from '@/axios'
    import SelectService from "@/components/SelectService";
    import EmpSearch from "@/components/EmpSearch";
    import EmpEvaluate from "@/components/EmpEvaluate";
    import EvaQrcode from '@/components/after_evaluate/EvaQrcode'

    export default{
        name:"Evaluate",
        components: {
            empSearch:EmpSearch,
            selectService:SelectService,
            empEvaluate:EmpEvaluate,
            evaQrcode:EvaQrcode,
        },
        data(){
            return{
                localitem:this.getLocalItem(),
                selected_service:{},
                selected_emp:{},
                selected_dept:null,
                prev_emp_qsearch:"",
                qr_status:false,
                current_state:'',
                qrcode_uriMulti: false
            }
        },
        mounted(){
            //ยกเลิกการเลือก selected_service เมื่อทำการกดปุ่มย้อนกลับมาจากหน้าเลือก พนักงาน
            EventBus.$on('clear_selected_service', params => {
                this.selected_service = {}
            })

            EventBus.$on('clear_selected_emp', params => {
                this.selected_emp = {}
            })
        },
        methods: {
            //กำหนดค่า selected_service เมื่อเลือก บริการ
            setSelectedService(item){
                this.selected_service = item
            },
            //กำหนดค่า selected_emp เมื่อเลือก พนักงาน
            setSelectedEmp(item){
                this.selected_emp = item
            },
            //กำหนดค่า selected_dept เมื่อเลือก ฝ่าย
            setSelectedDept(item){
                this.selected_dept = item.dept_id
            },
            set_qsearch(q){
                this.prev_emp_qsearch = q
            },
            set_Scanqr() {
                this.qr_status = true
            },
            gotoSearch () {
                this.current_state=''
                this.qrcode_uriMulti=false
            },
             async sendto(send_chanel){ /* ส่งให้ผู้ประเมินหลายคน */
                console.log('send_chanel', send_chanel)
                this.qrcode_uriMulti = true
                let error_msg_text = send_chanel=='email' ? 'เกิดข้อผิดพลาด ไม่สามารถส่ง Email ได้!!':'เกิดข้อผิดพลาด ไม่สามารถสร้าง QR Code ได้'
                let eva_prop = {
                    username:this.localitem.user_id,//คนที่ถูกประเมิน คนที่ login App อยู่
                    em_code:this.selected_emp.EM_CODE,//รหัสพนักงานผู้ที่ประเมิน คนที่ต้องการส่งลิงค์
                    service_id:this.selected_service.serviceD_id,
                    service_dept_id: this.selected_service.dept_id,
                    service_dept_code: this.selected_service.dept_code
                }

                try {
                    const uri = send_chanel=='email' ? '/serviceSendEmail':'/createURIMulti'
                    const res = await axios.post(uri, eva_prop)

                    if (res.data.status=='ok') {
                        if (send_chanel=='email') {
                            this.current_state = 'email'
                        } else {
                            // https://mobileapps.lpn.co.th/
                            this.qrcode_uri = 'https://mobileapps.lpn.co.th/service-excellence/#/eval?code='+res.data.code
                            // this.qrcode_uri = 'http://localhost:8080/service-excellence/#/eval?code='+res.data.code
                            this.current_state = 'qrcode'
                        }
                    }else{
                        this.current_state = 'evaluate'
                        this.snackbar.show = true
                        this.snackbar.msg = error_msg_text
                        return false
                    }


                } catch (err) {
                    console.log(err.message)
                }
            }
        }

    }
</script>

<style>
</style>